import styled from 'styled-components';

export const IconContainerElement = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 15px;
`;
